// Operation — 5 KPIs (Visites effectuées / payées / à payer / Visiteurs / Installateurs)
import { MapPin, CheckCircle2, Clock, Users, Hammer, Loader2 } from "lucide-react";
import { useOperationFetch } from "./useOperationFetch";
import { hasDevisInstallateur } from "../../utils/tenantProfile";

function Kpi({ title, value, icon: Icon, accent, subtitle }) {
  return (
    <div className="rounded-xl p-4"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs mb-1" style={{ color: "var(--oh-text-muted)" }}>{title}</p>
          <p className="text-2xl font-bold truncate" style={{ color: "var(--oh-text)" }}>{value}</p>
          {subtitle && <p className="text-[11px] mt-1 truncate" style={{ color: "var(--oh-text-secondary)" }}>{subtitle}</p>}
        </div>
        <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: `${accent}20` }}>
          <Icon className="w-4 h-4" style={{ color: accent }} />
        </div>
      </div>
    </div>
  );
}

export default function OperationKpisWidget() {
  const { data, loading } = useOperationFetch();
  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;
  const t = data?.totaux || {};
  const pct = t.avec_date_visite ? Math.round((t.visites_payees / t.avec_date_visite) * 100) : 0;
  // 🔑 Règle UNIQUE serveur (compter_visiteurs), la même que la grille Visiteurs :
  // ⛔ par_visiteur.length = visiteurs AVEC dossiers, pas les actifs.
  const visiteurs = data?.visiteurs || { actifs: 0, avec_dossiers: 0 };
  const installateurs = (data?.par_installateur || []).length;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-testid="operation-kpis-widget">
      <Kpi title="Visites effectuées" value={t.visites_effectuees ?? t.avec_date_visite ?? 0} icon={MapPin}
        accent="var(--oh-stat-blue-text)" subtitle={`sur ${t.dossiers || 0} dossiers`} />
      <Kpi title="Visites payées" value={t.visites_payees || 0} icon={CheckCircle2}
        accent="#10b981" subtitle={`${pct}% des visites`} />
      <Kpi title="À payer" value={t.visites_non_payees || 0} icon={Clock}
        accent="var(--oh-stat-amber-text)" subtitle="Visites non payées" />
      <Kpi title="Visiteurs actifs" value={visiteurs.actifs} icon={Users}
        accent="#8b5cf6" subtitle={`${visiteurs.avec_dossiers} avec dossiers · ${t.avec_visiteur || 0} dossiers assignés`} />
      {/* 🔴 N°756-1 — « Installateurs (0) » chez un artisan qui POSE LUI-MÊME.
          ⚠️ Le widget entier reste (ses 4 autres KPI sont universels) : c'est
          CETTE carte qui suit la capacité de SOUS-TRAITANCE, comme le bloc du
          dossier (N°690-2) et l'entrée de menu (N°728-2). */}
      {hasDevisInstallateur() && (
        <Kpi title="Installateurs" value={installateurs} icon={Hammer}
          accent="var(--oh-stat-cyan-text)" subtitle={`${t.dossiers_recuperes || 0} récupérés`} />
      )}
    </div>
  );
}
